import axios from 'axios'

import { logoutUser } from 'Actions/account_action'
import { store } from '../store.index'
import { setServicePage } from './website_actions'
import { getFbTrackingData } from '../utils/helper'

function client() {
  axios.interceptors.request.use(
    async config => {
      let awsWafToken = localStorage.getItem('aws-waf-token')
      const rwgToken = localStorage.getItem('rwg_token')
      // Forward Meta's Browser ID/Click ID/external id so the API can pass
      // them to the Conversions API - improves Event Match Quality
      // (fbevents.js cookies aren't visible cross-domain to the API server).
      const { fbp, fbc, externalId } = getFbTrackingData()

      // If no token exists, fetch a new one
      if (!awsWafToken) {
        try {
          awsWafToken = await window.AwsWafIntegration.getToken()
          localStorage.setItem('aws-waf-token', awsWafToken)
        } catch (error) {
          return Promise.reject(error)
        }
      }

      // Add headers to the request
      if (config.headers) {
        config.headers = {
          ...(config?.headers && { ...config?.headers }),
          'x-aws-waf-token': awsWafToken,
          ...(!config?.url?.includes('inbox') && {
            'x-rwg-token': rwgToken || '',
            ...(fbp ? { 'X-FB-Browser-Id': fbp } : {}),
            ...(fbc ? { 'X-FB-Click-Id': fbc } : {}),
            ...(externalId ? { 'X-FB-External-Id': externalId } : {})
          })
        }
        if (config.data instanceof FormData) {
          config.headers['content-type'] = 'multipart/form-data'
        }
      }

      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    async response => {
      setServicePage(false)(store.dispatch)

      // Handle 202 status - fetch new token and retry
      if (response.status === 202) {
        try {
          // Fetch new AWS WAF token
          const newToken = await window.AwsWafIntegration.getToken()
          localStorage.setItem('aws-waf-token', newToken)

          // Update the original request headers with new token
          const originalRequest = response.config
          if (originalRequest.headers) {
            originalRequest.headers['x-aws-waf-token'] = newToken
          }

          // Retry the original request with new token
          console.log('🔄 Retrying request with new AWS WAF token')
          return axios(originalRequest)
        } catch (error) {
          return Promise.reject(error)
        }
      }

      return response
    },
    error => {
      if (error.response?.status === 401) {
        // Guests have no session to drop; logging them out mid-checkout would
        // discard the page they are on.
        if (localStorage.getItem('customerkey')) {
          logoutUser()(store.dispatch)
          window.location = '/login'
        }
      } else if (error.response?.status === 503) {
        setServicePage(true)(store.dispatch)
      }
      return Promise.reject(error)
    }
  )

  return axios
}

export { client }
